import {Component, EventEmitter, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HeaderService} from '../../../core/services/header.service';
import {AuthService} from '../../../core/security/auth.service';
import {merge} from 'rxjs';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import {FaxLogsDatasource} from './fax-logs.datasource';
import {FaxReportService as FaxReportsApiService} from '../../../api/services/fax-report.service';
import {FaxLogsRequest} from '../../../api/models/fax-logs-request';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { PhoneNumberPipe } from '../../../core/pipes/phone-number.pipe';
import { DateTimePipe } from '../../../core/pipes/date-time.pipe';

@Component({
    selector: 'app-fax-logs-grid',
    templateUrl: './fax-logs-grid.component.html',
    styleUrls: ['./fax-logs-grid.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        NgClass,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AsyncPipe,
        PhoneNumberPipe,
        DateTimePipe,
    ],
})
export class FaxLogsGridComponent implements OnDestroy, OnInit {
  displayedColumns: string[] = [
    'type',
    'faxDate',
    'tnFrom',
    'tnTo',
    'status',
    'pages',
  ];
  @Input() filterChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  additionalFilter: any = {};
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  dataSource: FaxLogsDatasource;

  constructor(public dialog: MatDialog,
              public headerService: HeaderService, public authService: AuthService,
              private faxReportsService: FaxReportsApiService) {
  }

  ngOnInit() {
    this.dataSource = new FaxLogsDatasource(this.faxReportsService);

    this.filterChangeEvent?.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData(this.getDataFilter());
  }

  getDataFilter(): FaxLogsRequest {
    const baseRequest = {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
    };

    return Object.assign(baseRequest, this.additionalFilter || {});
  }

  ngOnDestroy() {
  }
}
